/**
 * contains the abi and contract address
*/

class ArtistsContract {
    constructor() {
        this.abi = [
	{
		"inputs": [],
		"stateMutability": "nonpayable",
		"type": "constructor"
	},
	{
		"anonymous": false,
		"inputs": [
			{
				"indexed": true,
				"internalType": "bytes32",
				"name": "name",
				"type": "bytes32"
			},
			{
				"indexed": true,
				"internalType": "bytes32",
				"name": "linkType",
				"type": "bytes32"
			},
			{
				"indexed": false,
				"internalType": "string",
				"name": "link",
				"type": "string"
			}
		],
		"name": "ArtistInfo",
		"type": "event"
	},
	{
		"inputs": [
			{
				"internalType": "bytes32",
				"name": "artistName",
				"type": "bytes32"
			},
			{
				"internalType": "address",
				"name": "user",
				"type": "address"
			}
		],
		"name": "claimArtist",
		"outputs": [],
		"stateMutability": "nonpayable",
		"type": "function"
	},
	{
		"inputs": [
			{
				"internalType": "bytes32",
				"name": "ipfsHash",
				"type": "bytes32"
			}
		],
		"name": "deleteSampleByArtist",
		"outputs": [],
		"stateMutability": "nonpayable",
		"type": "function"
	},
	{
		"inputs": [
			{
				"internalType": "bytes32",
				"name": "artistName",
				"type": "bytes32"
			},
			{
				"internalType": "bytes32",
				"name": "linkType",
				"type": "bytes32"
			},
			{
				"internalType": "string",
				"name": "link",
				"type": "string"
			}
		],
		"name": "newArtistInfo",
		"outputs": [],
		"stateMutability": "nonpayable",
		"type": "function"
	},
	{
		"inputs": [
			{
				"internalType": "bytes32",
				"name": "artistName",
				"type": "bytes32"
			},
			{
				"internalType": "uint32",
				"name": "releaseId",
				"type": "uint32"
			},
			{
				"internalType": "string",
				"name": "releaseName",
				"type": "string"
			},
			{
				"internalType": "bytes32",
				"name": "coverArtHash",
				"type": "bytes32"
			},
			{
				"internalType": "bytes32",
				"name": "releaseType",
				"type": "bytes32"
			}
		],
		"name": "newRelease",
		"outputs": [],
		"stateMutability": "nonpayable",
		"type": "function"
	},
	{
		"inputs": [
			{
				"internalType": "bytes32",
				"name": "artistName",
				"type": "bytes32"
			},
			{
				"internalType": "bytes32",
				"name": "ipfsHash",
				"type": "bytes32"
			}
		],
		"name": "newSampleByArtist",
		"outputs": [],
		"stateMutability": "nonpayable",
		"type": "function"
	},
	{
		"anonymous": false,
		"inputs": [
			{
				"indexed": true,
				"internalType": "bytes32",
				"name": "artistName",
				"type": "bytes32"
			},
			{
				"indexed": true,
				"internalType": "uint32",
				"name": "releaseId",
				"type": "uint32"
			},
			{
				"indexed": false,
				"internalType": "string",
				"name": "releaseName",
				"type": "string"
			},
			{
				"indexed": false,
				"internalType": "bytes32",
				"name": "coverArtHash",
				"type": "bytes32"
			},
			{
				"indexed": false,
				"internalType": "bytes32",
				"name": "releaseType",
				"type": "bytes32"
			}
		],
		"name": "ReleaseInfo",
		"type": "event"
	},
	{
		"anonymous": false,
		"inputs": [
			{
				"indexed": true,
				"internalType": "bytes32",
				"name": "artistName",
				"type": "bytes32"
			},
			{
				"indexed": true,
				"internalType": "bytes32",
				"name": "ipfsHash",
				"type": "bytes32"
			}
		],
		"name": "SampleByArtist",
		"type": "event"
	},
	{
		"inputs": [
			{
				"internalType": "bytes32",
				"name": "artistName",
				"type": "bytes32"
			}
		],
		"name": "unclaimArtist",
		"outputs": [],
		"stateMutability": "nonpayable",
		"type": "function"
	}
        ];

        this.contractAddress = '0x0C8aB6a2ED347F076ed69f9eBf05967a8A889400';
    }

    getContract(web3) {
        return new web3.eth.Contract(this.abi, this.contractAddress);
    }
}

export default ArtistsContract;
